/**
 * @module utils/currency
 */

function numberFormat (number, decimals, decPoint, thousandsSep) {
  decPoint = typeof decPoint !== 'undefined' ? decPoint : '.'
  thousandsSep = typeof thousandsSep !== 'undefined' ? thousandsSep : ','

  let parts = number.toFixed(decimals).split('.')
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSep)

  return parts.join(decPoint)
}

export function formatCurrency (number, decimals) {
  if (isNaN(number)) number = 0
  if (typeof number === 'undefined') {
    return 'N/A'
  }
  if (decimals === undefined) { decimals = 2 }
  // let numb = numberFormat(number, decimals, ',', '.')
  let numb = numberFormat(parseFloat(number), decimals, ',', '.')
  return numb
  // return number.toFixed(2).replace('.', ',')
}

export function formatCurrency2 (number, decimals) {
  let original = number
  if (number === '') return ''
  if (typeof number === 'undefined') {
    return 0
  }
  if (number === '') return ''
  number = number.toString()
  let result = number
  if (decimals === undefined) { decimals = 2 }
  if ((number.indexOf('.') !== -1 || number.indexOf(',') !== -1)) {
    // If , is before . format is UK
    if (number.indexOf(',') < number.indexOf('.')) {
      // console.log('Number', number, ' UK format')
      result = numberFormat(parseFloat(number), decimals, ',', '.')
    } else {
      // Format is DK
      // console.log('Number', number, ' DK format')
      // if (number.indexOf(',') === -1) result += (',' + '0'.repeat(decimals))
    }
    // result += (',' + '0'.repeat(decimals))
  } else {
    if (typeof original === 'number' && decimals > 0) result += (',' + '0'.repeat(2))
  }
  // console.log('Was', original, 'Format', number, 'to', result)
  return result
}

// Formats 1.000,00 as 1000.00 (to string)
export function reverseFormatCurrency (number) {
  if (!(typeof number === 'string' || typeof number === 'number')) return number
  if (typeof number === 'number') {
    number = number.toString()
  }
  number = replaceAll(number, '.', '')
  return replaceAll(number, ',', '.')
}

// Formats 1.000,00 as 1000.00 (to number)
export function reverseFormatCurrency2 (number) {
  if (typeof number === 'number') return number
  if (typeof number === 'undefined') return 0
  number = number.toString()
  number = replaceAll(number, '.', '')
  number = replaceAll(number, ',', '.')
  let result = parseFloat(number)
  if (isNaN(result)) result = 0
  return result
}

export function replaceAll (str, search, replacement) {
  return str.split(search).join(replacement)
}



// WEBPACK FOOTER //
// ./src/app/utils/currency.js